import axios from "axios";
import * as actionType from "../../constant/actionType";
export const GetAllIndividualForEmail = (search) => {
  return (dispatch) => {
    const config = {
      method: "get",
      url: `${actionType.environment_url}/api/admin/GetAllIndividualForEmail`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      params: {
        search: search,
      },
    };
    
    return axios(config)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return error;
      });
  };
};
